import $http from '../api/http'
import filter from '../utils/filter';

const templates = {
  // 获取签名列表
  async getSignatures (params) {
    return $http('/api/signatures', {
      method: 'GET',
      params: { ...params }
    });
  },
  // 添加一个签名
  async addSignature (params) {
    return $http('/api/signatures', {
      method: 'POST',
      data: { ...params }
    });
  },
  // 删除一个签名
  async delSignature (id) {
    return $http(`/api/signatures/${id}`, {
      method: 'DELETE'
    });
  },
  // 创建模板
  async createTemplate (params) {
    return $http('/api/templates', {
      method: 'POST',
      data: { ...filter(params) }
    });
  },
  // 编辑模板
  async editTemplate (params) {
    return $http(`/api/templates/${params.id}`, {
      method: 'PATCH',
      data: { ...params }
    });
  },
  // 获取模板列表
  async getTemplates (params) {
    return $http('/api/templates', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  // 获取模板信息
  async getTemplateInfo (id) {
    return $http(`/api/templates/${id}`);
  },
  // 删除一个模板
  async delTemplate (id) {
    return $http(`/api/templates/${id}`, {
      method: 'DELETE'
    });
  },
  // 更新回调地址
  async updateCallBack (params) {
    return $http(`/api/users`, {
      method: 'PATCH',
      data: { ...params }
    });
  },
  // 获取媒体短信模板列表
  async getMmsTemplates (params) {
    return $http('/api/mms/templates', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  // 删除超级模板
  async delMmsTemplate (id) {
    return $http(`/api/mms/templates/${id}`, {
      method: 'DELETE'
    });
  },
  // 创建媒体短信模板
  async createMmsTemplate (params) {
    return $http('/api/mms/templates', {
      method: 'POST',
      data: params,
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  },
  async getMaterialLibs (params) {
    return $http('/api/materialLibs', {
      method: 'GET',
      params: { ...params }
    })
  },
  async updateMaterialLibs (params) {
    return $http('/api/materialLibs', {
      method: 'POST',
      data: params,
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  },
  async delMaterialLibs (id) {
    return $http(`/api/materialLibs/${id}`, {
      method: 'DELETE'
    })
  }
};

export default templates;



// WEBPACK FOOTER //
// ./src/api/templates.js